module.exports = __webpack_public_path__ + "static/img/__8218.1bb64b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8218.jpg
// module id = 9Xu0
// module chunks = 0